export default {
    home: {
        text_1: "重新定义链上交易",
        text_2: "开始交易",
        text_3: "{x} 用户已经加入",
    },
};
